import { Component, OnInit } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import * as moment from 'moment';

@Component({
    selector: 'app-dash-tooltip',
    templateUrl: './dash-tooltip.component.html',
    styleUrls: ['./dash-tooltip.component.scss'],
    standalone: false  // NOSONAR
})
export class DashTooltip implements ITooltipAngularComp {
  data: any;
  field: string;
  map = {
    stop: '',
    unloadStart: '',
    unloadEnd: '',
    reloadStart: '',
    reloadEnd: '',
    actual: '',
    delayPickup: '',
    delayUnload: '',
  };
  yardDispatchMap = {
    stop: '',
    start: '',
    end: '',
    actual: '',
  };
  output: string;

  agInit(params: { field: string } & ITooltipParams): void { // NOSONAR
    this.data = params.data; 
    this.field = params.field;
    if (this.field == 'pu1') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_1_name,
        this.data.stop_1_nacode,
        this.data.stop_1_cacode,
        this.data.stop_1_mtmcode
      );
      this.map.unloadStart = this.data.stop_1_parts_unload_start;
      this.map.reloadStart = this.data.stop_1_parts_reload_start;
      this.map.unloadEnd = this.data.stop_1_parts_unload_end;
      this.map.reloadEnd = this.data.stop_1_parts_reload_end;
      this.map.actual = this.data.stop_1_actual;
      this.map.delayPickup = this.data.stop_1_delay_pickup;
      this.map.delayUnload = this.data.stop_1_delay_unload;
    } else if (this.field == 'pu2') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_2_name,
        this.data.stop_2_nacode,
        this.data.stop_2_cacode,
        this.data.stop_2_mtmcode
      );
      this.map.unloadStart = this.data.stop_2_parts_unload_start;
      this.map.reloadStart = this.data.stop_2_parts_reload_start;
      this.map.unloadEnd = this.data.stop_2_parts_unload_end;
      this.map.reloadEnd = this.data.stop_2_parts_reload_end;
      this.map.actual = this.data.stop_2_actual;
      this.map.delayPickup = this.data.stop_2_delay_pickup;
      this.map.delayUnload = this.data.stop_2_delay_unload;
    } else if (this.field == 'pu3') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_3_name,
        this.data.stop_3_nacode,
        this.data.stop_3_cacode,
        this.data.stop_3_mtmcode
      );
      this.map.unloadStart = this.data.stop_3_parts_unload_start;
      this.map.reloadStart = this.data.stop_3_parts_reload_start;
      this.map.unloadEnd = this.data.stop_3_parts_unload_end;
      this.map.reloadEnd = this.data.stop_3_parts_reload_end;
      this.map.actual = this.data.stop_3_actual;
      this.map.delayPickup = this.data.stop_3_delay_pickup;
      this.map.delayUnload = this.data.stop_3_delay_unload;
    } else if (this.field == 'pu4') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_4_name,
        this.data.stop_4_nacode,
        this.data.stop_4_cacode,
        this.data.stop_4_mtmcode
      );
      this.map.unloadStart = this.data.stop_4_parts_unload_start;
      this.map.reloadStart = this.data.stop_4_parts_reload_start;
      this.map.unloadEnd = this.data.stop_4_parts_unload_end;
      this.map.reloadEnd = this.data.stop_4_parts_reload_end;
      this.map.actual = this.data.stop_4_actual;
      this.map.delayPickup = this.data.stop_4_delay_pickup;
      this.map.delayUnload = this.data.stop_4_delay_unload;
    } else if (this.field == 'pu5') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_5_name,
        this.data.stop_5_nacode,
        this.data.stop_5_cacode,
        this.data.stop_5_mtmcode
      );
      this.map.unloadStart = this.data.stop_5_parts_unload_start;
      this.map.reloadStart = this.data.stop_5_parts_reload_start;
      this.map.unloadEnd = this.data.stop_5_parts_unload_end;
      this.map.reloadEnd = this.data.stop_5_parts_reload_end;
      this.map.actual = this.data.stop_5_actual;
      this.map.delayPickup = this.data.stop_5_delay_pickup;
      this.map.delayUnload = this.data.stop_5_delay_unload;
    } else if (this.field == 'pu6') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_6_name,
        this.data.stop_6_nacode,
        this.data.stop_6_cacode,
        this.data.stop_6_mtmcode
      );
      this.map.unloadStart = this.data.stop_6_parts_unload_start;
      this.map.reloadStart = this.data.stop_6_parts_reload_start;
      this.map.unloadEnd = this.data.stop_6_parts_unload_end;
      this.map.reloadEnd = this.data.stop_6_parts_reload_end;
      this.map.actual = this.data.stop_6_actual;
      this.map.delayPickup = this.data.stop_6_delay_pickup;
      this.map.delayUnload = this.data.stop_6_delay_unload;
    } else if (this.field == 'pu7') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_7_name,
        this.data.stop_7_nacode,
        this.data.stop_7_cacode,
        this.data.stop_7_mtmcode
      );
      this.map.unloadStart = this.data.stop_7_parts_unload_start;
      this.map.reloadStart = this.data.stop_7_parts_reload_start;
      this.map.unloadEnd = this.data.stop_7_parts_unload_end;
      this.map.reloadEnd = this.data.stop_7_parts_reload_end;
      this.map.actual = this.data.stop_7_actual;
      this.map.delayPickup = this.data.stop_7_delay_pickup;
      this.map.delayUnload = this.data.stop_7_delay_unload;
    } else if (this.field == 'pu8') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_8_name,
        this.data.stop_8_nacode,
        this.data.stop_8_cacode,
        this.data.stop_8_mtmcode
      );
      this.map.unloadStart = this.data.stop_8_parts_unload_start;
      this.map.reloadStart = this.data.stop_8_parts_reload_start;
      this.map.unloadEnd = this.data.stop_8_parts_unload_end;
      this.map.reloadEnd = this.data.stop_8_parts_reload_end;
      this.map.actual = this.data.stop_8_actual;
      this.map.delayPickup = this.data.stop_8_delay_pickup;
      this.map.delayUnload = this.data.stop_8_delay_unload;
    } else if (this.field == 'pu9') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_9_name,
        this.data.stop_9_nacode,
        this.data.stop_9_cacode,
        this.data.stop_9_mtmcode
      );
      this.map.unloadStart = this.data.stop_9_parts_unload_start;
      this.map.reloadStart = this.data.stop_9_parts_reload_start;
      this.map.unloadEnd = this.data.stop_9_parts_unload_end;
      this.map.reloadEnd = this.data.stop_9_parts_reload_end;
      this.map.actual = this.data.stop_9_actual;
      this.map.delayPickup = this.data.stop_9_delay_pickup;
      this.map.delayUnload = this.data.stop_9_delay_unload;
    } else if (this.field == 'pu10') {   // NOSONAR
      this.map.stop = this.entityName(
        this.data.stop_10_name,
        this.data.stop_10_nacode,
        this.data.stop_10_cacode,
        this.data.stop_10_mtmcode
      );
      this.map.unloadStart = this.data.stop_10_parts_unload_start;
      this.map.reloadStart = this.data.stop_10_parts_reload_start;
      this.map.unloadEnd = this.data.stop_10_parts_unload_end;
      this.map.reloadEnd = this.data.stop_10_parts_reload_end;
      this.map.actual = this.data.stop_10_actual;
      this.map.delayPickup = this.data.stop_10_delay_pickup;
      this.map.delayUnload = this.data.stop_10_delay_unload;
    } else if (this.field == 'dispatch') {   // NOSONAR
      this.yardDispatchMap.stop =
        this.data.dispatch_name + ' (' + this.data.dispatch_nacode + ')';
      this.yardDispatchMap.start = this.data.dispatch_start_date;
      this.yardDispatchMap.end = this.data.dispatch_end_date;
      this.output =
        `Dispatch: ${this.yardDispatchMap.stop}\n` +
        `Dispatch Start: ${
          this.yardDispatchMap.start !=   null ? this.yardDispatchMap.start : ''      // NOSONAR
        }\n` +
        `Dispatch End: ${
          this.yardDispatchMap.end !=   null ? this.yardDispatchMap.end : ''                  // NOSONAR
        }`;
    } else if (this.field == 'unload') {   // NOSONAR
      this.yardDispatchMap.start = this.data.unload_start;
      this.yardDispatchMap.end = this.data.unload_end;
      this.output =
        `Unload Start: ${
          this.yardDispatchMap.start !=   null ? this.yardDispatchMap.start : ''           // NOSONAR
        }\n` +
        `Unload End: ${
          this.yardDispatchMap.end !=   null ? this.yardDispatchMap.end : ''                 // NOSONAR
        }\n`;
      if (this.data.delay_unload !=   null) {                            // NOSONAR
        this.output =
          this.output +
          `DD Unload: ${
            this.data.delay_unload !=   null ? this.data.delay_unload : ''                        // NOSONAR
          }\n`;
      }
      if (this.data.unldtool) {
        this.output =
          this.output +
          `Scanned Actual: ${
            this.data.yard_arrival_actual !=   null                        // NOSONAR
              ? this.data.yard_arrival_actual
              : ''
          }`;
      } else {
        this.output =
          this.output +
          `Scanned Actual: ${
            this.data.unload_actual !=   null ? this.data.unload_actual : ''              // NOSONAR
          }`;
      }
    } else {
      this.yardDispatchMap.stop =
        this.data.yard_name + ' (' + this.data.yard_nacode + ')';
      this.yardDispatchMap.start = this.data.yard_arrival_start;
      this.yardDispatchMap.end = this.data.yard_arrival_end;
      this.yardDispatchMap.actual = this.data.yard_arrival_actual;
      this.output =
        `Yard: ${this.yardDispatchMap.stop}\n` +
        `Yard Arrival Start: ${
          this.yardDispatchMap.start !=   null ? this.yardDispatchMap.start : ''                   // NOSONAR
        }\n` +
        `Yard Arrival End: ${
          this.yardDispatchMap.end !=   null ? this.yardDispatchMap.end : ''                  // NOSONAR
        }\n` +
        `Actual Arrival: ${
          this.yardDispatchMap.actual !=   null ? this.yardDispatchMap.actual : ''                       // NOSONAR
        }`;
    }
    if (!this.output) {
      this.output =
        `P/U: ${this.map.stop}\n` +
        `Planned Start: ${
          this.map.reloadStart !=   null ? this.map.reloadStart : ''                     // NOSONAR
        }\n` +
        `Planned End: ${
          this.map.reloadEnd !=   null ? this.map.reloadEnd : ''                        // NOSONAR
        }\n` +
        `${
          this.map.delayPickup !=   null ? 'DD Pickup: ' + this.map.delayPickup + '\n': ''                 // NOSONAR
        }` +
        `${
          this.map.delayUnload !=   null ? 'DD Unload: ' + this.map.delayUnload + '\n': ''                         // NOSONAR
        }` +
        `Scanned Actual: ${this.map.actual !=   null ? this.map.actual : ''}`;                       // NOSONAR
    }
  }

  entityName(name, naCode, caCode, mtmCode) {
    return `${name} (NA: ${naCode}, CA: ${caCode == null ? '' : caCode}, MTM: ${   // NOSONAR
      mtmCode == null ? '' : mtmCode    // NOSONAR
    })`;
  }
}
